module.exports = __webpack_public_path__ + "img/icon-3.e6c8433b.png";